import { memo, useEffect, useRef, useState, useCallback } from "react";
import EpollQuestionAnswer from "./EpollQuestionAnswer";
import styles from "./EpollAnswers.module.css";
import { Button, Input, Dropdown, Modal, Popover, Select, Switch, message, Tag, Empty } from "antd";
import { Bookmark, Comment } from "@mui/icons-material";
import api from "../../api/api";
import { HighlightFilled, DeleteFilled, MinusOutlined, CopyFilled } from "@ant-design/icons";
import FlagMapper from "../../Util/FlagMapper";
import ExportExcel from "../../Util/ExportExcel";
import { connect } from "react-redux";
import CheckPermission from "../../Util/CheckPermission";
import { Tooltip } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { findFlagRef } from "../../Containers/Pages/UserRoadmap/UserRoadmap";
import WarningIcon from "@mui/icons-material/Warning";

const EpollAnswers = ({
  formDto,
  formId,
  answers,
  roadmapId,
  answersNote,
  checkFlagExistsInRoadmap,
  setAnswersNote,
  allFlags,
  answersHighlight,
  answersChecked,
  questionToTypes,
  questionToFlags,
  insertQuestionFlagsToRoadmap,
  unBookmarkRemoveFlags,
  questionAnswers,
  answerId,
  flagsRef,
  starQuestions,
  setStarQuestions,
  userData,
  role,
  permissions,
  search,
  setSearch,
  isValidUUID = false,
  showImportantOnly,
  flagIgnoredByGenerator = (i) => false,
}) => {
  const [newNote, setNewNote] = useState("");
  const [noteModal, setNoteModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showHighlightOnly, setShowHighlightOnly] = useState(false);
  const [showTypes, setShowTypes] = useState(true);
  const [showBookmarkOnly, setShowBookmarkOnly] = useState(false);
  const [selectedText, setSelectedText] = useState("");
  const [questionTypes, setQuestionTypes] = useState([]);
  const [selectedType, setSelectedType] = useState([]);

  const [showStarsOnly, setShowStarsOnly] = useState(false);
  const [showBookmarkOnlyFilter, setShowBookmarkOnlyFilter] = useState(false);
  // const [showImportantOnly, setShowImportantOnly] = useState(false);
  const [showCommentOnly, setShowCommentOnly] = useState(false);
  const [ignoreFlags, setIgnoreFlags] = useState([]);
  const [importantQuestions, setImportantQuestions] = useState(new Map());
  const [processedQuestionAnswers, setProcessedQuestionAnswers] = useState([]);

  const noteInputRef = useRef(null);
  const loadQuestionTypes = () => {
    api.get("/question-types").then((res) => {
      const data = res.data;
      setQuestionTypes(data);
    });
  };

  const loadImportantQuestions = useCallback(() => {
    if (!formId) return;
    api
      .get("/important-questions", {
        params: { formId },
      })
      .then(({ data }) => {
        const questionsArray = data.data || [];
        const questionsMap = new Map();
        questionsArray.forEach((iq) => {
          const key = iq.optionId ? `${iq.questionId}_${iq.optionId}` : `${iq.questionId}`;
          questionsMap.set(key, iq);
        });

        setImportantQuestions(questionsMap);
      })
      .catch(() => message.error("خطا در دریافت سوالات مهم"));
  }, [formId]);

  const isQuestionAnswerImportant = (questionAnswer) => {
    if (!(importantQuestions instanceof Map) || importantQuestions.size === 0) {
      return false;
    }

    const questionId = questionAnswer.id;
    const optionId = questionAnswer.optionId || null;

    return importantQuestions.has(optionId ? `${questionId}_${optionId}` : `${questionId}`);
  };

  useEffect(() => {
    loadQuestionTypes();
    getIgnoreFlagsList(formId);
    loadImportantQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formId]);

  useEffect(() => {
    const processedQA = questionAnswers.map((qa) => {
      qa.isImportant = isQuestionAnswerImportant(qa);
      return qa;  
    });

    setProcessedQuestionAnswers(processedQA);
  }, [questionAnswers, importantQuestions]);

  useEffect(() => {
    if (noteInputRef.current) {
      noteInputRef.current.focus();
    }
  }, [noteModal]);

  const getQuestionBookmarkStatus = (id) => answersNote[id]?.bookmark ?? false;
  const getQuestionNote = (id) => answersNote[id]?.note ?? "";

  const toggleQuestionBookmarkStatusInLocal = (id, bookmark) => {
    setAnswersNote({
      ...answersNote,
      [id]: { ...answersNote[id], bookmark },
    });
  };
  const setQuestionNoteInLocal = (id, note) => {
    setAnswersNote({
      ...answersNote,
      [id]: { ...answersNote[id], note },
    });
  };
  const exportData = () => {
    const json = questionAnswers;
    ExportExcel(json, userData.first_name + " " + userData.last_name + " پاسخنامه ");
  };
  const findQuestionToFlags = (questionId, log) => {
    // console.log({ questionToFlags, questionId, log });
    const a = (questionToFlags ?? []).filter((e) => e.id == questionId).map((e) => ({ id: e.flagId }));

    return a;

    let questionFlags = [];
    if (Array.isArray(questionToFlags)) {
      questionToFlags.forEach((el) => {
        if (`${el.epollQuestionId}` === `${questionId}`) {
          // if (log) {
          // }
          questionFlags = el.flags;
        }
      });
    }
    return questionFlags;
  };
  const addNote = (questionId) => {
    setLoading(true);
    api
      .post("/roadmaps/addanswernote", {
        roadmapId: `${roadmapId}`,
        questionId: `${questionId}`,
        note: newNote,
      })
      .then(() => {
        setQuestionNoteInLocal(questionId, newNote);
        setNewNote("");
        setNoteModal(null);
        setLoading(false);
        message.success("یادداشت با موفقیت افزوده شد");
      })
      .catch(() => {
        setLoading(false);
        message.error("افزون یادداشت با خطا مواجه شد");
      });
  };
  const removeNote = (questionId) => {
    setLoading(true);
    api
      .post("/roadmaps/removeanswernote", {
        roadmapId: `${roadmapId}`,
        questionId: `${questionId}`,
      })
      .then(() => {
        setQuestionNoteInLocal(questionId, "");
        setNewNote("");
        setNoteModal(null);
        setLoading(false);
        message.success("یادداشت با موفقیت حذف شد");
      })
      .catch(() => {
        setLoading(false);
        message.error("خطا در حذف یادداشت");
      });
  };
  const addBookmark = (questionId, questionAnswer, flagId) => {
    // setLoading(true);
    // api
    //   .post("/roadmaps/add-answer-bookmark", {
    //     roadmapId: `${roadmapId}`,
    //     questionId: `${questionId}`,
    //   })
    //   .then(() => {
    //     toggleQuestionBookmarkStatusInLocal(questionId, true);
    //     setLoading(false);
    //     message.success(".سوال با موفقیت نشان دار شد");
    //   })
    //   .catch(() => {
    //     setLoading(false);
    //     message.error(".نشان دار شدن سوال با مشکل مواجه شد");
    //   });

    // if (questionAnswer) {  // name changed to flagId
    //   insertQuestionFlagsToRoadmap(
    //     findQuestionToFlags(questionAnswer.id),
    //     questionAnswer.question,
    //     `${questionId}`.split("_")?.at(0)
    //   );
    // }
    console.log("Epoll answers function", { flagId, questionAnswer });
    if (flagId && questionAnswer) {
      insertQuestionFlagsToRoadmap([flagId], questionAnswer.question, `${questionId}`.split("_")?.at(0));
    }
  };
  const removeBookmark = (questionId) => {
    unBookmarkRemoveFlags(`${questionId}`.split("_")?.at(0));
    setLoading(true);
    api
      .post("/roadmaps/remove-answer-bookmark", {
        roadmapId: `${roadmapId}`,
        questionId: `${questionId}`,
      })
      .then(() => {
        toggleQuestionBookmarkStatusInLocal(questionId, false);
        setLoading(false);
        message.success("نشان سوال با موفقیت حذف شد");
      })
      .catch(() => {
        setLoading(false);
        message.error("خطا در حذف نشان سوال");
      });
  };
  const addHighlight = (questionId) => {
    setLoading(true);
    api
      .post("/roadmaps/addhighlight", {
        roadmapId: `${roadmapId}`,
        questionId: `${questionId}`,
        highlightedText: selectedText,
      })
      .then(() => {
        setLoading(false);
        answersHighlight[questionId] = Array.isArray(answersHighlight[questionId]) ? [...answersHighlight[questionId], selectedText] : [selectedText];
        message.success(".هایلایت با موفقیت نشان انجام شد");
      })
      .catch(() => {
        setLoading(false);
        message.error(".هایلایت با مشکل مواجه شد");
      });
  };
  const removeHighlight = (questionId) => {
    setLoading(true);

    api
      .post("/roadmaps/removehighlight", {
        roadmapId: `${roadmapId}`,
        questionId: `${questionId}`,
      })
      .then(() => {
        setLoading(false);
        delete answersHighlight[questionId];
        message.success(".حذف هایلایت با موفقیت انجام شد");
      })
      .catch(() => {
        setLoading(false);

        message.error(".حذف هایلایت با مشکل مواجه شد");
      });
  };
  const addCheck = (questionId, onSuccess) => {
    setLoading(true);
    api
      .post("/roadmaps/addsetflagofquestion", {
        roadmapId: `${roadmapId}`,
        questionId: `${questionId}`,
      })
      .then(() => {
        if (onSuccess) {
          onSuccess();
        }
        setLoading(false);
        message.success(".سوال تیک دار شد");
      })
      .catch(() => {
        setLoading(false);
        message.error(".تیک دار شدن سوال با مشکل مواجه شد");
      });
  };
  const removeCheck = (questionId, onSuccess) => {
    setLoading(true);
    api
      .post("/roadmaps/removesetflagofquestion", {
        roadmapId: `${roadmapId}`,
        questionId: `${questionId}`,
      })
      .then(() => {
        if (onSuccess) {
          onSuccess();
        }
        setLoading(false);
        message.success(".حذف تیک سوال با موفقیت انجام شد");
      })
      .catch(() => {
        setLoading(false);
        message.error(".حذف تیک سوال با مشکل مواجه شد");
      });
  };
  const starQuestionHandler = (questionId) => {
    if (starQuestions.indexOf(questionId) !== -1) {
      setStarQuestions((stars) => stars.filter((star) => `${star}` !== questionId));
      // send unstar request
      api
        .patch(`/roadmaps/${roadmapId}/unstar-question`, {
          questionKey: questionId,
        })
        .then((res) => {});
    } else {
      setStarQuestions((stars) => [...stars, questionId]);
      // send star request
      api
        .patch(`/roadmaps/${roadmapId}/star-question`, {
          questionKey: questionId,
        })
        .then((res) => {});
    }
  };
  const getIgnoreFlagsList = (id) => {
    api
      .get(`/question-ignore-flag/${id}`)
      .then(({ data }) => setIgnoreFlags(data))
      .catch(() => message.error("خطا در دریافت کارت های حذفی"));
  };
  const getRelatedFlagsToQuestion = (questionId, answerId) => {
    let shouldAddFlags = { flags: [] };
    if (answerId) {
      if (isValidUUID) {
        const c2 = questionToFlags.filter((val) => val?.id == questionId && answerId == val?.answer_id).map((e) => e.flagId);
        shouldAddFlags.flags.push(...Array.from(new Set(c2 ?? [])));
      } else {
        const c1 = questionToFlags.find((val) => val?.epollQuestionId == questionId && answerId == val?.epollAnswerId);
        shouldAddFlags.flags.push(...(c1?.flags ?? []));
      }
    }

    const shouldRemoveFlags = ignoreFlags
      .filter((cond) => (answerId ? `${answerId}` === `${cond.answer_id}` && `${questionId}` === `${cond.question_id}` : `${questionId}` === `${cond.question_id}` && cond.answer_id === null))
      .map((el) => el?.bom_item?.id)
      .filter((e) => e);

    if (!shouldAddFlags && !shouldRemoveFlags.length === 0) return [];

    let final = [...shouldAddFlags?.flags];

    final.push(...shouldRemoveFlags?.filter((flId) => !final.includes(flId)));

    final = final.map((id) => {
      const flag = findFlagRef({ id }, allFlags);
      const flagInserted = checkFlagExistsInRoadmap(id);
      let flagRemoved = false;
      flagRemoved = shouldRemoveFlags?.includes(id);
      let color = "green";
      if (!flagInserted) color = "yellow";
      if (flagRemoved) color = "red";

      return {
        ...flag,
        color,
        flagRemoved: flagRemoved ? true : false,
        flagInserted: flagInserted ? true : false,
      };
    });

    return final.filter((val) => val);
  };

  const questionAnswersElements = processedQuestionAnswers
    // toggle: star
    ?.filter((el) => {
      if (!showStarsOnly || el.type === "break") return true;
      return starQuestions.indexOf(`${el.id}_${el.answer_id}`) !== -1;
    })
    // toggle: bookmarks
    ?.filter((el) => {
      if (!showBookmarkOnlyFilter || el.type === "break") return true;

      const bookmarkArr = findQuestionToFlags(el.id);

      return bookmarkArr.length > 0;
    })
    // toggle: comment
    ?.filter((el) => {
      if (!showCommentOnly || el.type === "break") return true;

      let addingId = el?.answer_id ? `${el?.id}_${el?.answer_id}` : el?.id;

      const questionNote = getQuestionNote(addingId);
      return questionNote && questionNote.trim() !== "";
    })
    // toggle: important
    ?.filter((el) => {
      if (!showImportantOnly || el.type === "break") return true;
      return el.isImportant;
    })
    ?.map((questionAnswer, index) => {
      if ((questionAnswer?.type ?? questionAnswer?.field_type) === "break" && questionAnswer?.label?.trim() !== "") {
        return (
          <div
            id={`break-label-${questionAnswer.id}`}
            key={`break-label-${questionAnswer.id}`}
            className="break-question"
            style={{
              backgroundColor: "#9EA4B5",
              padding: "0.8rem",
              borderRadius: "0.2rem",
              fontWeight: "500",
              fontSize: "1.1rem",
              textAlign: "center",
            }}
          >
            {questionAnswer?.label}
          </div>
        );
      }

      if (typeof questionAnswer.answer == "undefined" || questionAnswer.answer.trim() == "") {
        return;
      }

      let isImportant = questionAnswer.isImportant;

      if (role === "result_editor" && typeof questionAnswer.question !== "undefined") {
        if (
          questionAnswer.question.indexOf("mobile") !== -1 ||
          questionAnswer.question.indexOf("موبایل") !== -1 ||
          questionAnswer.question.indexOf("تلفن همراه") !== -1 ||
          questionAnswer.question.indexOf("تلفن_همراه") !== -1
        )
          return;
      }

      let questionType = "question";
      if (typeof questionAnswer.type !== "undefined" && questionAnswer.type) {
        questionType = questionAnswer.type;
      }
      let hasNote = false;
      let hasChecked = false;
      let hasHighlight = false;
      let questionNote = "";
      let bookmarkStatus = false;
      let isSegmentMatchTheType = false;
      let bookmarkFlags = findQuestionToFlags(questionAnswer.id);

      let types = null;
      let addingId = questionAnswer.id;
      if (questionAnswer.field_type === "checkboxes") {
        addingId = `${questionAnswer.id}_${questionAnswer.answer_id}`;
      }

      const flagsReportData = getRelatedFlagsToQuestion(questionAnswer.id, questionAnswer.answer_id);

      if (questionAnswer.answer_id) {
        addingId = `${questionAnswer.id}_${questionAnswer.answer_id}`;
      }

      if (answersNote) {
        bookmarkStatus = getQuestionBookmarkStatus(addingId);
        questionNote = getQuestionNote(addingId);
        hasNote = questionNote && questionNote.trim() !== "";
      }
      if (answersHighlight) {
        if (answersHighlight[addingId]) {
          hasHighlight = true;
        }
      }
      if (Array.isArray(questionToTypes)) {
        questionToTypes.forEach((el) => {
          if (`${el.epollQuestionId}` === `${questionAnswer.id}`) {
            if (Array.isArray(el.questionTypes)) {
              types = el.questionTypes.map((id) => {
                let element = null;
                if (selectedType.includes(id)) {
                  isSegmentMatchTheType = true;
                }
                questionTypes.forEach((t) => {
                  if (id === t.id) {
                    element = t;
                  }
                });
                return element;
              });
            }
          }
        });
      }
      const starButton = (
        <Tooltip title="نشان کردن" placement="top">
          <Button
            disabled={!roadmapId ? true : false}
            type={starQuestions.indexOf(`${questionAnswer.id}_${questionAnswer.answer_id}`) !== -1 ? "primary" : "default"}
            onClick={() => starQuestionHandler(`${questionAnswer.id}_${questionAnswer.answer_id}`)}
            size="small"
            className={styles.Button}
          >
            <StarIcon />
          </Button>
        </Tooltip>
      );
      const bookmarkButton = (
        <Popover
          title="کارت‌های متصل"
          content={
            <>
              {bookmarkFlags.length > 0 ? (
                bookmarkFlags
                  .map((el) => {
                    const flag = findFlagRef(el, allFlags);
                    if (!flag) return null;
                    const flagData = FlagMapper(flag?.type);
                    const ignored = flagIgnoredByGenerator(flag.id);
                    if (!flagData) return null;
                    return (
                      <Tag
                        style={{
                          cursor: ignored ? "not-allowed" : "pointer",
                          opacity: ignored ? 0.5 : 1,

                          border: checkFlagExistsInRoadmap(flag.id) ? "yellow 4px solid" : null,
                        }}
                        onClick={() => {
                          if (ignored) return;
                          addBookmark(addingId, questionAnswer, [flag.id]);
                        }}
                        color={flagData.titleColor}
                      >
                        <b>{flagData.title}</b>
                        <br />
                        {flag.title}
                      </Tag>
                    );
                  })
                  .filter((e) => e)
              ) : (
                <Tag icon={<MinusOutlined />} color="red">
                  ندارد
                </Tag>
              )}
            </>
          }
        >
          <Button
            disabled={!roadmapId ? true : false}
            type={bookmarkStatus ? "primary" : "default"}
            // onClick={() =>
            //   !bookmarkStatus
            //     ? addBookmark(addingId, questionAnswer)
            //     : removeBookmark(addingId)
            // }
            size="small"
            className={styles.Button}
          >
            <Bookmark />
          </Button>
        </Popover>
      );
      const flagsReport = (
        <Popover
          title="گزارش کارت ها"
          content={
            <>
              {flagsReportData?.length > 0 ? (
                flagsReportData?.map((data) => <Tag color={data.color}>{data.title ?? ""}</Tag>)
              ) : (
                <Tag icon={<MinusOutlined />} color="red">
                  ندارد
                </Tag>
              )}
            </>
          }
        >
          <Button type={"default"} size="small" className={styles.Button}>
            {flagsReportData?.length}
          </Button>
        </Popover>
      );
      const commnetButton = (
        <Button
          type={hasNote ? "primary" : "default"}
          disabled={!roadmapId ? true : false}
          onClick={() => {
            setNoteModal({ ...questionAnswer, addingId });
            setNewNote(questionNote);
          }}
          size="small"
          className={styles.Button}
        >
          <Comment />
        </Button>
      );
      if (
        ((showHighlightOnly && hasHighlight) || (showBookmarkOnly && hasNote) || (!showBookmarkOnly && !showHighlightOnly)) &&
        (isSegmentMatchTheType || selectedType.length === 0) &&
        `${questionAnswer.answer} ${questionAnswer.question}`.includes(search)
      ) {
        return (
          <div key={`${questionAnswer.id}_${questionAnswer.answerId}_${index}`}>
            {questionType === "break" && questionAnswer.label.trim() !== "" && (
              <>
                <h3 unselectable="on" className={styles.Title}>
                  {questionAnswer.label}
                </h3>
              </>
            )}
            {questionType === "question" && (
              <Dropdown
                trigger={["contextMenu"]}
                menu={{
                  items: [
                    {
                      label: (
                        <span
                          onClick={() => {
                            addHighlight(addingId);
                          }}
                        >
                          {" "}
                          <HighlightFilled /> <span>هایلایت</span>
                        </span>
                      ),
                      key: "1",
                    },
                    {
                      label: (
                        <span
                          onClick={() => {
                            removeHighlight(addingId);
                          }}
                        >
                          {" "}
                          <DeleteFilled /> <span>حذف هایلایت‌</span>
                        </span>
                      ),
                      key: "2",
                    },
                    {
                      label: (
                        <span
                          onClick={() => {
                            navigator.clipboard.writeText(selectedText);
                          }}
                        >
                          {" "}
                          <CopyFilled /> <span>کپی</span>
                        </span>
                      ),
                      key: "3",
                    },
                  ],
                }}
              >
                <div className={isImportant ? styles.EpollQuestionAnswerContainerImportant : styles.EpollQuestionAnswerContainer} key={questionAnswer.id}>
                  <EpollQuestionAnswer
                    highlightedText={answersHighlight && answersHighlight[addingId]}
                    questionAnswer={questionAnswer}
                    addingId={addingId}
                    addCheck={addCheck}
                    removeCheck={removeCheck}
                    showTypes={showTypes}
                    hasChecked={(isChecked) => {
                      hasChecked = isChecked;
                    }}
                    answersChecked={answersChecked}
                    key={questionAnswer.id + "_" + index}
                    types={types}
                  />

                  <div className={styles.ButtonsContainer}>
                    {starButton}
                    {/* {bookmarkFlags.length > 0 && bookmarkButton} */}
                    {bookmarkButton}
                    <Popover title="کامنت" content={<div>{hasNote ? questionNote : "کامنتی نوشته نشده."}</div>}>
                      {commnetButton}
                    </Popover>
                    {flagsReport}
                  </div>
                </div>
              </Dropdown>
            )}
          </div>
        );
      } else {
        return null;
      }
    })
    .filter((el) => el !== null);

  return (
    <>
      <div
        className={styles.EpollAnswers}
        onMouseUp={() => {
          const selected = window.getSelection().toString();
          if (selected.trim() !== "") {
            setSelectedText(selected);
            // alert(selected)
          }
        }}
      >
        <div className={styles.Row}>
          <Select
            placeholder="انتخاب نوع"
            showArrow
            showSearch={false}
            mode="multiple"
            onChange={(value) => {
              setSelectedType(value);
            }}
            style={{ width: "100%" }}
          >
            {questionTypes.map((type) => {
              return (
                <Select.Option key={type.id} value={type.id}>
                  {type.title}
                </Select.Option>
              );
            })}
          </Select>
        </div>
        {/* toggle: star questions */}
        <div className={styles.Row}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <StarIcon style={{ marginLeft: "0.2rem", color: "#858585" }} fontSize="small" />
            نمایش سوالات ستاره دار
          </div>
          <Switch onChange={(checked) => setShowStarsOnly(checked)} defaultChecked={showStarsOnly} />
        </div>
        {/* toggle: bookmarks */}
        <div className={styles.Row}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Bookmark style={{ marginLeft: "0.2rem", color: "#858585" }} fontSize="small" />
            نمایش سوالات بوکمارکی
          </div>
          <Switch onChange={(checked) => setShowBookmarkOnlyFilter(checked)} defaultChecked={showBookmarkOnlyFilter} />
        </div>
        {/* toggle: comments */}
        <div className={styles.Row}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Comment style={{ marginLeft: "0.2rem", color: "#858585" }} fontSize="small" />
            نمایش سوالات یادداشت دار
          </div>
          <Switch onChange={(checked) => setShowCommentOnly(checked)} defaultChecked={showCommentOnly} />
        </div>
        {/* toggle: important questions */}
        {/* <div className={styles.Row}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <WarningIcon
              style={{ marginLeft: "0.2rem", color: "#858585" }}
              fontSize="small"
            />
            نمایش سوالات مهم
          </div>
          <Switch
            onChange={(checked) => setShowImportantOnly(checked)}
            defaultChecked={showImportantOnly}
          />
        </div> */}
        {/* toggle: highlights */}
        <div className={styles.Row}>
          <div>نمایش سوالات هایلایت دار</div>
          <Switch
            onChange={(checked) => {
              setShowHighlightOnly(checked);
            }}
            defaultChecked={showHighlightOnly}
          />
        </div>
        {/* toggle: type of questions */}
        <div className={styles.Row}>
          <div>نمایش نوع سوالات</div>
          <Switch
            onChange={(checked) => {
              setShowTypes(checked);
            }}
            defaultChecked={showTypes}
          />
        </div>
        {/* export excel */}
        {CheckPermission("export_answers_excel", permissions) && (
          <div className={styles.Row}>
            <Button onClick={exportData}>خروجی اکسل</Button>
          </div>
        )}
        <hr />
        {answerId && (
          <>
            شناسه پاسخنامه: <b>{answerId}</b>
          </>
        )}
        {questionAnswersElements.length > 0 ? questionAnswersElements : <Empty description="سوال و جوابی پیدا نشد!" />}
      </div>

      {noteModal && (
        <Modal
          title={
            <p>
              {noteModal.question} : <b>{noteModal.answer}</b>
            </p>
          }
          footer={[
            // delete note
            <>
              {(answersNote[noteModal.addingId]?.note ?? "").trim() !== "" && (
                <Button
                  danger
                  type="primary"
                  loading={loading}
                  onClick={() => {
                    removeNote(noteModal.addingId);
                  }}
                >
                  حذف نوت
                </Button>
              )}
            </>,

            // cancel button
            <Button
              loading={loading}
              onClick={() => {
                setNoteModal(null);
                setNewNote("");
              }}
            >
              لغو
            </Button>,

            // submit edit
            <Button
              type="primary"
              loading={loading}
              onClick={() => {
                addNote(noteModal.addingId);
              }}
            >
              {`${answersNote[noteModal.addingId]?.note}`.trim() === "" ? "اعمال تغییرات" : "نشان دار کردن"}
            </Button>,
          ]}
          open={noteModal}
          onCancel={() => {
            setNoteModal(null);
            setNewNote("");
          }}
        >
          <p>کامنت:</p>
          <Input.TextArea
            ref={noteInputRef}
            autoFocus
            defaultValue={newNote}
            onBlur={(event) => {
              setNewNote(event.target.value);
            }}
          />
        </Modal>
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    role: state.userData ? state.userData.role : null,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
export default connect(mapStateToProps)(memo(EpollAnswers));
